import { HTMLParser } from '@dtk/public-website-ui-components';
import React from 'react';

const HtmlParserBlok = ({ blok }) => (
  <div className="mx-auto content-center px-4 sm:px-6 md:max-w-xl lg:max-w-2xl lg:px-8 xl:max-w-[50rem]">
    <HTMLParser key={blok._uid} htmlcode={blok.code} variation={blok.variation} rawStyle={blok.rawStyle}></HTMLParser>
  </div>
);
export default HtmlParserBlok;
